import React from "react";

import { Typography, Grid } from '@mui/material';
import { Sparklines, SparklinesCurve, SparklinesSpots, SparklinesReferenceLine } from 'react-sparklines';

export default function CDDSparkline(props) {
    return (
        <React.Fragment>
            <Grid container spacing={0} pt="16px">
                <Grid item xs={12}>
                    <Sparklines data={props.data} margin={6} min={0}>
                        {/* <SparklinesReferenceLine type="mean" /> */}
                        <SparklinesCurve style={{ strokeWidth: 3, stroke: "#000", fill: "#000" }} />
                        <SparklinesSpots size={4}
                            style={{ stroke: "#000", strokeWidth: 3, fill: "white" }} />
                    </Sparklines>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h6">{props.data[0]}</Typography>
                    <Typography variant="body2" color="primary">SY2016-17</Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <Typography variant="h6">{props.data[props.data.length - 1]}</Typography>
                    <Typography variant="body2" color="primary" >SY2020-21</Typography>
                </Grid>
            </Grid>
        </React.Fragment>

    )
}